import { ref } from "vue";
import GridParametros from "./GridParametros";
import { reactive } from "vue";
import { isArray } from "lodash";

function converterEnumParaTexto(value, enumPropsArray){
    let textoResultado
    enumPropsArray.forEach(obj => {
        if(obj.value === value){
            textoResultado = obj.text
        }
    });
    return textoResultado
}

function validaEmail(email = ''){
    // eslint-disable-next-line
    let validacaoEmailNFE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return validacaoEmailNFE.exec(email);
}

function validaVariavelPreenchida(variavel){
    return ['', undefined, null, [], {}, 0, '0'].includes(variavel);
}

// Normaliza CNPJ removendo APENAS a mascara (. / - espaco) e aplicando toUpperCase.
// Preserva letras e numeros (formato alfanumerico). NAO usar para telefone/CPF.
function normalizaCNPJ (cnpj = '') {
    return String(cnpj).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

// Formata CNPJ para exibicao. Alfanumerico + retrocompativel com numerico.
// Reusa normalizaCNPJ (1.1a: strip mascara + toUpperCase). Retorna o valor
// original se nao tiver 14 posicoes apos normalizar (fallback seguro).
function formatarCnpj (valor = '') {
    if (!valor) return valor
    var cnpjNormalizado = normalizaCNPJ(valor)
    if (cnpjNormalizado.length !== 14) return valor
    return cnpjNormalizado.replace(
        /^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})([0-9A-Z]{2})$/,
        '$1.$2.$3/$4-$5'
    )
}

function validaCNPJ (cnpj = '') {
    // Normalizacao nao-destrutiva (preserva [A-Z0-9]) ao inves de remover letras com \D
    var cnpjNormalizado = normalizaCNPJ(cnpj);

    if(!cnpjNormalizado) return false;

    if (cnpjNormalizado.length != 14) return false;

    let cnpjsInvalidosConhecidos = [
        '00000000000000',
        '11111111111111',
        '22222222222222',
        '33333333333333',
        '44444444444444',
        '55555555555555',
        '66666666666666',
        '77777777777777',
        '88888888888888',
        '99999999999999',
    ]

    // Elimina CNPJs invalidos conhecidos (sequencias numericas)
    if (cnpjsInvalidosConhecidos.includes(cnpjNormalizado)) return false;

    // Os 2 digitos verificadores devem ser numericos (regra SERPRO)
    if (!/^[0-9]{2}$/.test(cnpjNormalizado.substring(12))) return false;

    // Valor de cada caractere pela regra ASCII-48: '0'-'9' => 0-9, 'A'-'Z' => 17-42
    var valor = (ch) => ch.charCodeAt(0) - 48;

    // Valida DVs mantendo o algoritmo modulo 11 com pesos ciclicos 2..9
    var tamanho = cnpjNormalizado.length - 2
    var numeros = cnpjNormalizado.substring(0,tamanho);
    var digitos = cnpjNormalizado.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += valor(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
            pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != parseInt(digitos.charAt(0), 10))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpjNormalizado.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += valor(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != parseInt(digitos.charAt(1), 10))
          return false;

    return true;
}

function converterTextoParaEnum(text,enumPropsArray){
    let enumResultado
    enumPropsArray.forEach(obj => {
        if(obj.text === text){
           enumResultado = obj.value
        }
    });
    return enumResultado
}

function objectCustomAssign (alvo, origem) {
    Object.keys({...alvo}).forEach(chave => {
        if(!(alvo[chave] !== undefined && origem[chave] === undefined)){
            alvo[chave] = origem[chave]
        }
    })
}

function captalizeKeys(objOriginal){
    let objConvertido = {}
    for (var chave in objOriginal){
        objConvertido[chave.charAt(0).toUpperCase() + chave.substring(1)] = objOriginal[chave]
    }
    return objConvertido;
}

function formatarDados(data,novoValor){
    //formatar objeto entrada de dados para exibição  e retornar novoValor para não quebrar o back
    Object.keys(data).forEach((valor)=>{
      if(!data[valor]){
        data[valor] = novoValor
      }
   })
   return data
}

export const retornaDataNormalizada = (data = new Date()) => {
    const parametrosFormatacao = { minimumIntegerDigits: 2, useGrouping: false  }
    return `${data.getDate().toLocaleString('pt-BR', parametrosFormatacao)}-${(data.getMonth() + 1).toLocaleString('pt-BR', parametrosFormatacao)}-${data.getFullYear()}`
  }


//   export const toast = (tipo, titulo, texto, tempo = 2500) => {
//     if(!['error', 'warn', 'info', 'success'].includes(tipo)){
//       console.warn(`O tipo "${tipo}" não é valido para Toasts. Tipo trocado para "info"`)
//       tipo = 'info'
//     }
//     appToast.add({
//       severity: tipo,    
//       summary: titulo,
//       detail: texto,
//       life: tempo,
//     })
//   }


export const propriedadesGrid = {
    busca: {
      type: Number,
      default: 0,
    },
    parametros: {
      type: GridParametros,
      default: new GridParametros(),
    },
  }

  export const useGrid = (...args) => {
    let _filtros = ref([])
    args.forEach((a) =>
      _filtros.value.push({
        campo: a,
        valor: null,
      })
    )
  
    let busca = ref(0)
    function filtrar() {
      busca.value++
    }
  
    let a = new GridParametros()
    let _parametros = reactive(a)
  
    const limpar = () => {
      _filtros.value.forEach((x) => {
        if (isArray(x.valor)) x.valor = []
        else x.valor = null
      })
      _parametros.Filtros = _filtros
      busca.value++
    }
  
    return {
      filtros: _filtros.value,
      busca,
      parametros: _parametros,
      limpar: limpar,
      filtrar: filtrar,
    }
  }


  export const valorMonetario = (valorNaoFormatado) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valorNaoFormatado)
  }

  const valorMonetario4Digitos = (valor)  =>{
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 4
    }).format(valor)
  }

  const valorDecimalFormatado = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'decimal'
    }).format(valor)
  }


  export const desformata = (valor) => {
    return valor.replace(/[\D]/gm, '')
  }

const Tools = {
    converterEnumParaTexto,
    validaCNPJ,
    normalizaCNPJ,
    formatarCnpj,
    validaVariavelPreenchida,
    validaEmail,
    converterTextoParaEnum,
    objectCustomAssign,
    formatarDados,
    captalizeKeys,
    valorMonetario4Digitos,
    valorDecimalFormatado
}

export default Tools